dsf.mergeConfig(
  dsf.config,
  {
    webRoot: {
      //默认请求路径根
      default: "/",
      "statistics-cloud": "/",
    },
    file: {
      preViewServer: "/dsfa/",
    },
    //当前运行类型：platform--平台、product--产品、project--项目
    runType: "product",
    assetsDir: "./static/",
    //默认皮肤
    setting_public_default_theme: "darkred-theme",
    //默认字体大小
    setting_public_default_size: "normal",
    //默认顶部导航栏是否为窄条
    setting_public_default_header_mini: false,
    //页面右下角是否显示设计器跳转图标
    setting_public_gotoicon: "1",
    //登录成功后进入页面地址
    setting_public_login_success_to: "./index.html",
    //登录成功后跳转页面
    setting_public_mobile_login_success_to: "./mobile-index.html",
    //登录页地址
    setting_public_pc_login_page: "./page.html#/pc/login",
    setting_public_mobile_login_page: "./mobile-index.html#/mobile/login",
    //项目logo图片地址
    setting_public_logo_image: "",
    //项目名称
    setting_public_logo_title: "统计云",
    // 业务网登录页title
    intranet_login_page_title: "统计云",
    //默认用户头像
    setting_public_user_default_header: "./static/img/platform/defaultHeader.png",
    //菜单请求接口
    setting_public_home_menu_src: "/menu/getTree",
    //默认预览
    setting_public_file_host: "/",
    // 流程提示弹窗倒计时间，默认为3
    setting_flow_count_down_time: 3,
    // 5张首页打开方式 1:弹窗 2、跳转 3、打开新页面
    setting_openMode: "1",
    // 应用名映射
    setting_appToName: {
      应用管理平台: "应用管理",
      元数据及制度管理: "元数据",
      人事信息管理系统: "人事系统",
    },
    // 禁用头部logo 跳转
    setting_public_disable_head_logo_url: true,
    // 打开链接映射
    setting_nameToPath: {
      /* 用户中心 */
      在线用户人数: "platform/usercenter/user/onlinelist?appKey=dreamuPquTbLL",
      在线用户数量: "platform/usercenter/user/onlinelist?appKey=dreamuPquTbLL",
      机构数量: "platform/usercenter/unit/listdata?appKey=dreamuPquTbLL",
      用户数量: "platform/usercenter/user/platformlist?appKey=dreamuPquTbLL",
      权限数量: "platform/usercenter/privilege/list?appKey=dreamuPquTbLL",
      角色数量: "platform/usercenter/role/list?appKey=dreamuPquTbLL",
      角色组数量: "platform/usercenter/rolegroup/list?appKey=dreamuPquTbLL",
      证书数量: "platform/usercenter/certificate/list?appKey=dreamuPquTbLL",
      "近30天警告行为（人次）": "platform/usercenter/user/warnlist?type=warn&appKey=dreamuPquTbLL",
      "近30天危险行为（人次）": "platform/usercenter/user/warnlist?type=error&appKey=dreamuPquTbLL",
      机构用户树: "platform/org/unit/depttreeusercenter",
      用户访问量: "platform/run/log/statistics/analysetable?appKey=dreamuPquTbLL",
      警告危险行为: "platform/usercenter/user/warnlist?appKey=dreamuPquTbLL",
      /* 应用中心 */
      系统数量: "platform/resource/system/numlist",
      接口数量: "platform/resource/api/numlist",
      组件数量: "platform/resource/newcomponent/numlist",
      工具数量: "platform/resource/tool/numlist",
      算法数量: "platform/resource/algo/numlist",
      应用访问次数: "platform/resource/access/list",
      应用访问量: "platform/resource/applogin/list",
      访问总量: "platform/resource/access/list",
      /* 智能中心 */
      机器人模板数量: "/platformintellect/page.html#/pc/dsfa/intellect/robot/simplelist",
      工作站数量: "/platformintellect/page.html#/pc/dsfa/intellect/work/simplelist",
      启动机器人数量: "/platformintellect/page.html#/pc/dsfa/intellect/robot/simplelist?enable=1",
      启用工作站数量: "/platformintellect/page.html#/pc/dsfa/intellect/work/simplelist?state=1",
      预警数量: "/platformintellect/page.html#/pc/dsfa/intellect/stat/warnlist",
      异常数量: "/platformintellect/page.html#/pc/dsfa/intellect/stat/list?status=-9",
      /* 运行中心 */
      "认证服务-正常": "platform/run/oauth/list?level=0",
      "认证服务-异常": "platform/run/oauth/list?level=2",
      "认证服务-警告": "platform/run/oauth/list?level=1",
      "机构服务-正常": "platform/org/sync/unitlog?level=0",
      "机构服务-异常": "platform/org/sync/unitlog?level=2",
      "机构服务-警告": "platform/org/sync/unitlog?level=1",
      "用户服务-正常": "platform/org/sync/userlog?level=0",
      "用户服务-异常": "platform/org/sync/userlog?level=2",
      "用户服务-警告": "platform/org/sync/userlog?level=1",
      "日志服务-正常": "platform/run/logservice/list?level=0",
      "日志服务-异常": "platform/run/logservice/list?level=2",
      "日志服务-警告": "platform/run/logservice/list?level=1",
      /* 信息中心 */
      今日新增问卷调查: "platform/run/monitor/application/asqaddlist",
      正在进行问卷调查: "platform/run/monitor/application/asqrunlist",
      今日填报问卷: "platform/run/monitor/application/asqwirtelist",
      今日新增文档: "platform/run/monitor/application/wikiadd",
      今日修改文档: "platform/run/monitor/application/wikieditlist",
      今日删除文档: "platform/run/monitor/application/wikidellist",
      今日接口调用: "platform/run/monitor/application/interfacecalllist",
      今日推送监控指标: "platform/run/monitor/application/termlist",
      今日新增用户: "platform/run/monitor/application/userlist",
      今日新增机构: "platform/run/monitor/application/unitlist",
      超过三个月未登录用户: "platform/run/monitor/application/morethanthreemothlist",
      用户越权访问: "platform/run/monitor/application/ultraviresaccesslist",
      非工作时间登录: "platform/run/monitor/application/notworkloginlist",
      异常登录: "platform/run/monitor/application/loginexceptionlist",
      登录总人数: "platform/run/monitor/application/loginperonlist",
      登录总次数: "platform/run/monitor/application/logincountlist",
      /* 知识库 */
      接入应用: "platform/home/yyzxsy/insertapplist",
      注销应用: "platform/home/yyzxsy/logoutapplist",
      问卷数量: "platform/home/yyzxsy/asqlist",
      填报数量: "platform/home/yyzxsy/asqfilllist",
      应用资源管理: "dsfa/oua/application/edit",
      辅调员数量: "platform/servey/assistant/management/readonlylist",
      调查对象数量: "platform/usercenter/respondents/readonlylist",
      "近30天警告、危险行为(人次)": "platform/usercenter/user/warnlist",
      // 最新问卷申请: "platform/home/yyzxsy/insertapplist",
      系统登录排行: "platform/resource/access/list2",
      应用管理首页机构数量: "platform/usercenter/unit/listdata2",
      应用管理首页用户数量: "platform/usercenter/user/platformlist2",
      应用管理首页辅调员数量: "platform/servey/assistant/management/readonlylist",
    },
    setting_public_smpublickey: "",
    internet_login_page_title: "统计云-登录",
    internet_login_icp: "***",
    internet_login_mail: "***",
    internet_login_phone: "***",
    // 软证书助手
    tongfang_window_url: "https://chr.cds/cert/cert_all_query",
    tongfang_xc_url: "https://127.0.0.1:26080/cert/cert_all_query",
    // 直报证书下载地址
    tongfang_cds:
      "https://gmzs.stats.gov.cn/error.html?cds_id=wjpcds&app_id=tjytest&back_url=https://tjy.stats.gov.cn/platform/page.html#/pc/internetLogin",
    // 直报登录地址
    tongfang_login_url: "https://wjpssltest.stats.gov.cn/survey/loginCA",
    // 专报证书下载地址
    geer_cds:
      "https://gmzs.stats.gov.cn/tjyonline/error.html?cds_id=tjycds&app_id=tjyzx&back_url=https://tjy.stats.gov.cn&lwzb_url=https://tjysslzx.stats.gov.cn/survey/loginCA",
    // 专报登录地址
    geer_login_url: "https://tjysslzx.stats.gov.cn/survey/loginCA",
  },
  window.$$serverConfig ? window.$$serverConfig : {},
  (function () {
    try {
      return JSON.parse(window.$$serverConfig.setting_public_config_js.trim());
    } catch (ex) {
      return {};
    }
  })(),
  window.$$config ? window.$$config : {}
);
window.$$webRoot = dsf.config.webRoot;
